import * as React from "react";
import styled from "styled-components";
import ContentSection from "../../components/about/content-section";
import ImageSection from "../../components/about/image-sectioin";
import { useEffect } from "react";
import AOS from "aos";

const StudyAnywhere = () => {
  useEffect(() => {
    // Initialize AOS with settings to only animate once
    AOS.init({
      once: true, // This is the key setting - animations will only happen once
      mirror: false, // Don't mirror animations when scrolling back up
      duration: 600,
      offset: 100, // Controls when the animation triggers
      easing: "ease-out"
    });

    // Refresh AOS on component mount
    AOS.refresh();
  }, []);

  return (
    <StudySection>
      <div data-aos="fade-in" data-aos-duration="600" data-aos-delay="100">
        <ContentSection
          imageSrc={"/assets/home/laptop.png"}
          imageAlt={"Study Dashboard laptop"}
          title={"Study Anytime, Anywhere"}
          description={
            "Enjoy a seamless experience on both mobile and desktop with purpose-built layouts for efficient studying on the go or at home."
          }
        />
      </div>
      <div data-aos="fade-in" data-aos-duration="600">
        <ImageSection
          imageSrc={"/assets/home/study.webp"}
          imageAlt={"Study Dashboard Interface"}
        />
      </div>
    </StudySection>
  );
};

const StudySection = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 48px 16px 32px 96px;
  max-width: 1456px;
  margin: 0 auto;
  width: 100%;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    padding: 32px 16px;
    text-align: center;
  }
`;

export default StudyAnywhere;
